import { css, styled } from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';
import { BodyTextRegularC } from '@/shared/ui/typography2';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

export const ContentRow = styled.a`
  //border-radius: 8px;
  //min-height: 120px;
  cursor: pointer;
  //background: linear-gradient(243deg, #27262b 43.77%, #ff6900 220.99%), #1b1b5d;
  flex-basis: 30%;
  display: flex;
  height: 100%;
  gap: 6px;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;
  color: #fff;
  text-shadow: 0px 1.5px 1.5px rgba(11, 21, 46, 0.5);
  //font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 23.4px */
  position: relative;
  min-width: 100px;
  @media (max-width: 768px) {
    min-width: 100px;
    min-height: 80px;
    font-size: 12px;

    ${brandIsPh &&
    css`
      min-width: 60px;
      min-height: auto;
      gap: 0;
      padding: 4px 0 8px;
      background:
        linear-gradient(#232122, #232122) padding-box,
        linear-gradient(90deg, #232122 0%, #f4be2b 50%, #232122 100%) border-box;
      border: 1px solid transparent;
      border-radius: 8px;
    `}
  }
`;

export const IconContainer = styled.div<{ $isActive: boolean, $isDisabled: boolean }>`
    display: flex;
    align-items: center;
    //margin: 0 auto 2px;
    height: 80px;
    //width: 80px;
    padding: 16px;
    background: linear-gradient(243deg, #27262b 43.77%, #ff6900 220.99%), #1b1b5d;
    border-radius: 8px;
    object-fit: contain;

    ${({ $isActive }) =>
            $isActive &&
            `
      background: #3D3C41;
  `}
    ${({ $isDisabled }) =>
            $isDisabled &&
            `
      opacity:0.4;
      cursor: not-allowed;
  `}

  @media (max-width: 768px) {
    ${brandIsPh &&
    css`
      position: relative;
      height: 54px;
      width: 54px;
      margin: 0 auto;
      padding: 0;
      background: transparent;
      border-radius: 0;
    `}
  }
`;

export const BannersWrapper = styled.div`
  ${WRAPPER}
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: stretch;
  margin-top: 18px;
  margin-bottom: 18px;
    
  @media (max-width: 768px) {
    //margin-top: 0;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    gap: 8px;
    min-height: 178px;

    ${brandIsPh &&
    css`
      margin-top: 12px;
      gap: 6px;
      min-height: auto;
    `}
  }
`;
export const ContentRows = styled.div`
  display: flex;

  gap: 8px;
  flex: none;
  width: 100%;
  height: 122px;
    
  overflow-x: auto;
  padding-top: 16px;
    
  a {
    flex: 1;
  }
  @media (max-width: 768px) {
    margin: 0;
    //padding: 24px 0 12px 0;
      padding-top: 8px;
    overflow-x: scroll;
    scroll-behavior: smooth;

    a:first-child {
      margin-left: 18px;
    }
    a:last-child {
      margin-right: 18px;
    }

    ${brandIsPh &&
    css`
      height: auto;
      margin-top: -4px;
      padding-top: 4px;
      gap: 4px;

      a {
        min-width: 60px;
      }
      a:first-child {
        margin-left: 12px;
      }
      a:last-child {
        margin-right: 12px;
      }
    `}
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BannersSkeletonBar = styled.div`
  flex: 1;
  height: 80px;

  @media (max-width: 768px) {
    margin-left: 18px;
    margin-right: 18px;

    ${brandIsPh &&
    css`
      height: 78px;
      margin-left: 12px;
      margin-right: 12px;
    `}
  }

  .react-loading-skeleton {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const TruncatedText = styled(BodyTextRegularC)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90px;
  margin: auto;

  @media (max-width: 768px) {
    ${brandIsPh &&
    css`
      min-width: 0;
      width: 100%;
      font-size: 8px;
      line-height: 1.3;
      max-width: 100%;
      text-transform: uppercase;
    `}
  }
`;


